var React = require('react');
var VisPercent = require('./VisPercent.jsx');
var StatsTable = require('./StatsTable.jsx');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');

var AttackingStats = React.createClass({
    render : function(){
        
        var stats = this.props.stats;
        var possession = this.props.possession;
        var territory = this.props.territory;
        
        return (
            <article className="sub-module" style={{overflow:'auto'}}>
                <header className="bordered">
                    <h1>Attacking</h1>
                </header>

                <div className="stacked-rl">
                    <div className="col-a content">
                        <TeamCompareHeader heading="Possession" home={this.props.home} away={this.props.away} />
                        <VisPercent colors={this.props.colors} percent={possession}/>
                        <TeamCompareHeader noTeams={'no-teams'} heading="Territory" home={this.props.home} away={this.props.away} />
                        <VisPercent colors={this.props.colors} percent={territory} large={true} />
                    </div>
                    <div className="col-b content">
                        <TeamCompareHeader bordered={'bordered'} home={this.props.home} away={this.props.away} />
                        <StatsTable stats={this.props.attackingStats} />
                    </div>
                </div>
            </article>
        );
    }
});

module.exports = AttackingStats;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/AttackingStats.jsx
 **/